import Subnav from 'global/subnav';

class About {
  constructor(elems) {

    this.elems = elems;

    this.Subnav = new Subnav('about', this.elems);
  }
}

export default About;



// WEBPACK FOOTER //
// ./app/javascript/about/index.js